import React from "react";
import Carousel from "./WebimarCarousel";

const WebinarDetails = ({isDesktopView}) => {
  return (
    <div className="webinarDetails">
      <div className="webinarDetails__header">
        <div className="webinarDetails__header--heading">
        FREE WEBINAR DETAILS
        </div>
        <div className="webinarDetails__header--content">
        Once in a lifetime opportunity to learn & grow
        </div>
      </div>
      <div className="webinarDetails__content">
        <Carousel isDesktopView={isDesktopView} />
      </div>
    </div>
  );
};

export default WebinarDetails;
